import { render } from "./OrdersApp.vue?vue&type=template&id=f3397054&scoped=true"
import script from "./OrdersApp.vue?vue&type=script&lang=js"
export * from "./OrdersApp.vue?vue&type=script&lang=js"

import "./OrdersApp.vue?vue&type=style&index=0&id=f3397054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3397054"]])

export default __exports__